export interface AppIcon {
  icon: string;
  colorCode?: string;
  child?: AppIcon[];
}

export interface ShortcutIcon {
  icon: string;
}
